import type { CustomerUserCategory } from "shared";

/**
 * Offline shape used before the categories endpoint answers, and when it returns
 * nothing. Ids are PLACEHOLDERS ("standard", not a uuid) — never send one to the
 * API; `BasicInformationForm` guards against exactly that.
 */
export const FALLBACK_CATEGORIES: CustomerUserCategory[] = [
  {
    mapping_id: "customer_owner",
    name: "C-level",
    tier: "customer_owner",
    is_default: false,
  },
  { mapping_id: "vip", name: "VIP", tier: "vip", is_default: false },
  {
    mapping_id: "manager",
    name: "Manager",
    tier: "manager",
    is_default: false,
  },
  {
    mapping_id: "standard",
    name: "Standard",
    tier: "standard",
    is_default: true,
  },
];
